<div [zippy]="['footer_dropdown', index]"
     [zippyHideUp]="['footer_dropdown', index]">
    @switch (column.type) {
    @case ('links') {
    <ul>
        @for (item of column.links; track $index) {
        <li class="p1 p-l-3 p-t-3 p-b-3 b-b"
            [tradeClass]="'!b-col-42 !col-11 b-col-43 col-12'">
            <href [link]="item.link">
                <span *iCms="'label' of item"></span>
            </href>
        </li>
        }
    </ul>
    }
    }
</div>